import { Injectable } from '@angular/core';
// import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { DashboardTransportData } from '@classes/dashboard-transport-data';
import { Observable } from 'rxjs';
import { DashboardMaterialData } from '@classes/dashboard-material-data';
import { DashboardContractResumeData } from '@classes/dashboard-contract-resume-data';
import { EnvConfigurationService } from './env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/dashboard';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getDashboardTransport(): Observable<DashboardTransportData> {
    return this.http.get<DashboardTransportData>(`${this.basePath}/getdashboardtransport`);
  }

  getDashboardMaterial(startDate: string, endDate: string): Observable<DashboardMaterialData> {
    return this.http.get<DashboardMaterialData>(`${this.basePath}/getdashboardmaterial?startDate=${startDate}&endDate=${endDate}`);
  }

  getDashboardContractResume(): Observable<Array<DashboardContractResumeData>> {
    return this.http.get<Array<DashboardContractResumeData>>(`${this.basePath}/getdashboardcontractresume`);
  }
}
